import React from "react";
import ContactForm from './Components/ContactForm.js';
function Apps() {
  return (
    <div className="App">
      {/* Your existing sections */}

      <h2>Contact Me</h2>
      <ContactForm />
    </div>
  );
}

const certifications = [
  "Microsoft Certified: Azure Administrator Associate (AZ-104)",
  "Microsoft 365 Administrator (MS-102)",
  "Microsoft Certified: Azure Fundamentals (AZ-900)",
  "Microsoft Certified: Security Operations Analyst Associate (SC-200)",
  "AWS Certified Certified SysOps Administrator – Associate",
  "AWS Certified Certified Cloud Practitioner",
];

const services = [
  "Intune Setup & Device Management",
  "Microsoft 365 Administration (Exchange, SharePoint, Teams)",
  "Azure AD / Entra ID Configuration",
  "Technical Support & Remote Troubleshooting",
  "VoIP / Virtual BPO Consultation",
  "Backup & Recovery Systems",
  "Computer Networking",
  "Cybersecurity & Endpoint Protection",
  "Computer Repair & Maintenance",
  "Data Recovery Solutions",
  "Home & Office Networking",
  "IT Consulting for Small Businesses",
  "Network Support & Optimization",
  "Virtual Assistance for IT Tasks",
];

export default function App() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900 font-sans p-6 max-w-4xl mx-auto">
      <header className="mb-10 text-center">
        <h1 className="text-4xl font-bold mb-2">Naqui Khadri, Mohammad</h1>
        <p className="text-lg text-gray-700">
          IT Professional | System Administrator | Cloud & Azure Specialist
        </p>
      </header>

      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-4 border-b border-gray-300 pb-2">About Me</h2>
        <p className="leading-relaxed whitespace-pre-line">
          {`Proactive and technically skilled IT professional with over 6 years of progressive experience in cloud operations, system administration, and infrastructure management across hybrid environments.

I specialize in managing Microsoft 365, Intune, Azure, and AWS core services including EC2, S3, IAM, CloudWatch, and VPC. I have hands-on expertise in automation, monitoring, and security using tools like PowerShell, Bash, AWS CLI, Microsoft Defender, and Microsoft Sentinel.

Additionally, I’m experienced in backup and disaster recovery, VMware virtualization, and enforcing compliance and device lifecycle policies. I’m certified in both Azure and AWS, with a solid foundation in cross-platform cloud support and enterprise IT operations.`}
        </p>
      </section>

      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-4 border-b border-gray-300 pb-2">Certifications</h2>
        <ul className="list-disc list-inside space-y-1">
          {certifications.map((cert, i) => (
            <li key={i}>{cert}</li>
          ))}
        </ul>
      </section>

      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-4 border-b border-gray-300 pb-2">Services Offered</h2>
        <ul className="list-disc list-inside space-y-1">
          {services.map((service, i) => (
            <li key={i}>{service}</li>
          ))}
        </ul>
      </section>

      <footer className="text-center mt-20 text-gray-600">
        <p>Connect with me on{" "}
          <a
            href="https://linkedin.com/in/naquikhadri"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            LinkedIn
          </a> or {" "}
          <a href="khadri775@gmail.com" className="text-blue-600 underline">
          Email
          </a>.
        </p>
      </footer>
    </div>
  );
}
